import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import { VideoItem, GroupType } from './types';
import VideoTableRow from './VideoTableRow';

export interface Column {
  key: string;
  label: string;
  width?: string;
  minWidth?: number;
  align?: 'left' | 'right' | 'center';
}

export interface VideoTableProps {
  videos: VideoItem[];
  columns: Column[];
  page: number;
  rowsPerPage: number;
  total: number;
  onPageChange: (page: number) => void;
  onPlay: (video: VideoItem) => void;
  onTagChange: (video: VideoItem, tag: string, isAdd: boolean) => void;
  onDelete: (videoId: string) => void;
  onShare: (video: VideoItem) => void;
  onZoneChange: (video: VideoItem, zone: string, checked: boolean) => void;
  onOpenGroupDialog: (video: VideoItem) => void;
  allGroups: GroupType[];
  ZONE_OPTIONS: { label: string; value: string }[];
  extractYouTubeId: (url: string) => string | null;
  formatViewCount: (count?: string) => string;
  formatDate: (dateStr?: string) => string;
  isGuest?: boolean; // 新增：是否為訪客用戶
}

const VideoTable: React.FC<VideoTableProps> = ({
  videos, columns, page, rowsPerPage, total, onPageChange, onPlay, onTagChange, onDelete, onShare,
  onZoneChange, onOpenGroupDialog, allGroups, ZONE_OPTIONS,
  extractYouTubeId, formatViewCount, formatDate, isGuest = false
}) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {columns.map(col => (
              <TableCell 
                key={col.key} 
                align={col.align || 'left'} 
                sx={{ width: col.width, minWidth: col.minWidth, fontWeight: 'bold' }}
              >
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <>
            {videos.map((video, idx) => (
              <VideoTableRow
                key={`video-table-${video.id}-${idx}-${Math.random().toString(36).substr(2, 9)}`}
                video={video}
                index={idx + 1 + page * rowsPerPage}
                onPlay={onPlay}
                onTagChange={onTagChange}
                onDelete={onDelete}
                onShare={onShare}
                onZoneChange={onZoneChange}
                onOpenGroupDialog={onOpenGroupDialog}
                allGroups={allGroups}
                ZONE_OPTIONS={ZONE_OPTIONS}
                extractYouTubeId={extractYouTubeId}
                formatViewCount={formatViewCount}
                formatDate={formatDate}
                columns={columns.map(c => c.key)}
                isGuest={isGuest}
              />
            ))}
          </>
        </TableBody>
      </Table>
      <Pagination
        count={Math.ceil(total / rowsPerPage)}
        page={page + 1}
        onChange={(_, p) => onPageChange(p - 1)}
        sx={{ my: 2, display: 'flex', justifyContent: 'center' }}
      />
    </TableContainer>
  );
};

export default VideoTable; 